//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "pw3d-success",
  data: function data() {
    return {
      data: {}
    };
  },

  computed: {
    lang: function lang() {
      return this.$root._route.params.lang;
    },

    websiteName: function websiteName() {
      var displayName = global.websiteSettings.extra_info.display_name;
      if (displayName) {
        return this.$root.trans('st_public.' + displayName);
      }
      return '';
    }
  }, mounted: function mounted() {
    this.doAuth();
  },

  methods: {
    doAuth: function doAuth() {
      this.loading = false;
      this.data.access_token = this.$route.query.access_token;
      this.data.refresh_token = this.$route.query.refresh_token;
      this.data.token_type = this.$route.query.token_type;
      this.data.expires_in = this.$route.query.expires_in;
      this.$auth.setToken(this.data.access_token, this.data.refresh_token, this.data.token_type, this.data.expires_in);
      this.$parent.$emit('login-logout-event');
      this.$router.push({ name: 'lang-successful-signup', params: { lang: this.lang } });
      this.$router.push({ name: 'lang-set-password', params: { lang: this.lang } });
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/var/www/html/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/_lang/pw3d-success.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/var/www/html/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/_lang/pw3d-success.vue
// module chunks = 32